import classNames from 'classnames';
import MaskedDisplay from 'components/ui/MaskedDisplay';

function Row({ label, value }) {
  return (
    <span className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-sm">
      <span className="text-gray-400 shrink-0">{label}:</span>
      <span className="text-gray-700">{value}</span>
    </span>
  );
}

export default function BankingProfileSummary({ profile, className }) {
  if (!profile) return null;
  const isDirectDeposit = !!profile.directDeposit;

  return (
    <span className={classNames('block space-y-1 text-gray-600', className)}>
      <span className="block font-medium text-gray-700">{isDirectDeposit ? 'Direct Deposit' : 'Paper Check'}</span>

      {profile.paymentName && <Row label="Make payable to" value={profile.paymentName} />}

      {isDirectDeposit && profile.accountType?.title && <Row label="Account type" value={profile.accountType.title} />}

      {profile.bankName && <Row label="Bank" value={profile.bankName} />}

      {isDirectDeposit && profile.routingNumber && (
        <Row label="Routing number" value={<MaskedDisplay value={profile.routingNumber} showLastXDigits={4} />} />
      )}

      {profile.accountNumber && (
        <Row label="Account number" value={<MaskedDisplay value={profile.accountNumber} showLastXDigits={4} />} />
      )}

      {profile.voidedCheckFileName && <Row label="Void check" value={profile.voidedCheckFileName} />}
    </span>
  );
}
